import { Component, Input, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';

@Component({
    selector: 'wait-image',
    template: '<div [class]="cssClass" [class.d-none]="!show"><img #img src="/assets/img/loading.gif" alt="Loading..." (blur)="setFocusToImg()" tabindex="-1"/></div>'
})
export class WaitImageComponent implements AfterViewChecked {

    private isVisible: boolean;
    @Input()
    private set show(value: boolean) {
        this.isVisible = value;
        if (!value)
            this.initialFocusSet = false;
    }
    private get show(): boolean {
        return this.isVisible;
    }

    @Input()
    private cssClass: string;

    @ViewChild('img')
    private imgRef: ElementRef;

    private initialFocusSet: boolean;

    private setFocusToImg = (): void => {
        if (this.imgRef)
            this.imgRef.nativeElement.focus();
    }

    ngAfterViewChecked(): void {
        if (this.initialFocusSet)
            return;

        this.setFocusToImg();
        this.initialFocusSet = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/wait-image.component/wait-image.component.ts